import React from 'react';

import type { TListingClient } from 'types/TListing';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import SellerInfoExpanded from './components/SellerInfoExpanded';

type TSellerInfoExpandedAppProps = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
};

const SellerInfoExpandedApp = ({ appState, environment }: TSellerInfoExpandedAppProps) => {
  const {
    listing: {
      seller,
      isCarAd,
      itemId,
      category,
      flags: { isAdmarkt },
      traits,
    },
  } = appState;

  return (
    <EnvironmentProvider value={environment}>
      <SellerInfoExpanded
        seller={seller}
        isCarAd={isCarAd}
        itemId={itemId}
        categoryId={category.id}
        showItemsCount={!isAdmarkt}
        traits={traits}
      />
    </EnvironmentProvider>
  );
};

export default SellerInfoExpandedApp;
